// eslint-disable-next-line no-unused-vars
/* global Drupal */

import { scrollIcon } from './atoms/ScrollIcon'
import { togglePopin } from './components/Accessibility/togglePopin'
import { activitiesCarousel } from './components/activitiesCarousel/activitiesCarousel'
import { audioComponent } from './components/AudioComponent/audioComponent'
import { toggleMenu } from './components/BurgerMenu/toggleMenu'
import { carbonFilter } from './components/carbonFilter/carbonFilter'
import { engagementScroll } from './components/engagementScroll/engagementScroll'
import { FilterJobSection } from './components/FilterJobSection/FilterJobSection'
import { graphRh } from './components/graphRh/graphRh'
import { toggleSlide } from './components/HomeOurActivities/toggle-slide'
import { infiniCaroussel } from './components/InfiniCarousel/InfiniCarousel'
import { keyNumber } from './components/KeyNumber/keyNumber'
import { showMoreArticles } from './components/media/showMoreArticles'
import { mediaSearch } from './components/MediaSearch/mediaSearch'
import { scrollNavbar } from './components/ScrollNavbar/scroll-navbar'
import { toggleForm } from './components/Search/ToggelForm'
import { searchBar } from './components/SearchBar/searchBar'
import { select2Init } from './components/select2Init/select2Init'
import { setupSelectedTerms } from './components/SelectedTerms/selected-terms'
import { socialShare } from './components/socialShare/socialShare'
import { cleanToken } from './components/tokenCleaner/tokenCleaner'
import { youtubeVideo } from './components/YoutubeVideo/youtube-video'
/*
 * Feature code example
 * */
setupSelectedTerms()
youtubeVideo()
select2Init()
toggleSlide()
toggleMenu()
togglePopin()
toggleForm()
// myFeature()
scrollIcon()
infiniCaroussel()
activitiesCarousel()
keyNumber()
searchBar()
scrollNavbar()
audioComponent()
socialShare()
FilterJobSection()
carbonFilter()
engagementScroll()
graphRh()
showMoreArticles()
mediaSearch()
cleanToken()

window.onYouTubeIframeAPIReady = function () {
  setTimeout(window.ytplayer.onYouTubeIframeAPIReady, 500)
}

/*
 * Slick
 * */
jQuery(function ($) {
  $('.slider_container.slider_home_banner').each(function () {
    $(this).slick({
      autoplay: true,
      speed: 500,
      fade: true,
      arrows: false
    })
  })

  $('.slider_container .center').each(function () {
    $(this).slick({
      // setting-name: setting-value
      centerMode: false,
      infinite: false,
      centerPadding: '20px',
      slidesToShow: 1.5,
      slidesToScroll: 1,
      speed: 300,
      initialSlide: 0,
      arrows: true,
      nextArrow: $(this).siblings('.button-arrow.next'),
      prevArrow: $(this).siblings('.button-arrow.prev'),
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            centerMode: true,
            arrows: false,
            slidesToShow: 1,
            dots: true
          }
        }
      ]
    })
  })

  $('.slider_container .directors_profile_height').each(function () {
    $(this).slick({
      centerMode: true,
      infinite: false,
      centerPadding: '20px',
      slidesToShow: 1,
      speed: 300,
      initialSlide: 0,
      arrows: true,
      adaptiveHeight: true,
      nextArrow: $(this).siblings('.button-arrow.next'),
      prevArrow: $(this).siblings('.button-arrow.prev'),
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    })

    const slideNumber = $(this).find('.direction_block_component').length

    $(this).on('afterChange', function (event, slick, currentSlide, nextSlide) {
      if (currentSlide === 0) {
        $(this).siblings('.button-arrow.prev').addClass('disabled')
        $(this).siblings('.button-arrow.next').removeClass('disabled')
      } else if (currentSlide === slideNumber - 1) {
        $(this).siblings('.button-arrow.prev').removeClass('disabled')
        $(this).siblings('.button-arrow.next').addClass('disabled')
      } else {
        $(this).siblings('.button-arrow.prev').removeClass('disabled')
        $(this).siblings('.button-arrow.next').removeClass('disabled')
      }
    })
  })

  $('nav.nav_main ul.main_nav>li.has_sub_menu').hover(
    function () {
      $(this).addClass('hover')
    },
    function () {
      $(this).removeClass('hover')
    }
  )

  /* -- Add/Remove class on footer contact dropdown list-- */
  $('footer.footer .contact .dropdown .dropdown-header').on('click', function () {
    // console.log('click')
    $(this).find('.dropdown-selected').toggleClass('false open')
    $(this).find('.icon').toggleClass('false open')
    $(this).siblings('.dropdown-body').toggleClass('false open')
  })

  /* -- Scroll Up/Down add class -- */
  let lastScrollTop = 0
  $(window).scroll(function (event) {
    const scroll = $(this).scrollTop()
    if (scroll > lastScrollTop) {
      // down
      $('body').addClass('scroll-down')
      $('body').removeClass('scroll-up')
    } else {
      // up
      $('body').addClass('scroll-up')
      $('body').removeClass('scroll-down')
    }
    lastScrollTop = scroll

    /* -- YellowFlag Bloc -- */
    if (scroll >= 500) {
      $('.discover_store_sticky .sticky-container').addClass('smaller')
    } else {
      $('.discover_store_sticky .sticky-container').removeClass('smaller')
    }
  })

  /* -- Media filter -- */

  // cache collection of elements so only one dom search needed
  const $mediaArticles = $('.article_item')
  let currentFilter = null

  $('.filter_link').click(function (e) {
    e.preventDefault()

    const filterVal = $(this).data('cat-media')

    // Supprimer la classe "active" des liens précédemment sélectionnés
    $('.filter_link').removeClass('active')

    if (filterVal === currentFilter) {
      // Si on reclique sur le même filtre, afficher tous les éléments
      $mediaArticles.show()
      currentFilter = null // Réinitialiser le filtre
    } else {
      // Sinon, masquer tous les éléments et afficher ceux correspondant au filtre
      $mediaArticles.hide()
      $mediaArticles
        .find('.single_article')
        .filter('.' + filterVal)
        .parent()
        .show()
      currentFilter = filterVal // Mettre à jour le filtre actuel
      $(this).addClass('active') // Ajouter la classe "active" sur le lien cliqué
    }
  })
})

// eslint-disable-next-line no-new
if (typeof Drupal !== 'undefined') {
  Drupal.behaviors.myWebformBehavior = {
    attach: function (context, settings) {
      const $ = jQuery
      const urlParams = new URLSearchParams(window.location.search)
      // let metier = urlParams.get('metier')
      const sub = urlParams.get('sub')

      if (sub) {
        setTimeout(() => {
          const secondDropdown = $('#edit-metiers-shs-0-1')
          if (secondDropdown) {
            secondDropdown.val(sub).trigger('change')
          }
        }, 0)
      }
    }
  }
}
